/**
 * Created by andrey on 17.02.2026
 */

const SyncUtils = {
    getHeader: function () {
        const header = {
            episode: levels.user.currentPhysicalLevel.episode,
            level: levels.user.currentPhysicalLevel.level,
            progress: levels.user.currentPhysicalLevel.progress,
            progressCompare: cleverapps.user.progressCompare,
            exp: ExpHelper.GetMainInstance().getExp(),
            payer: cleverapps.paymentsHistory.isPayer(),
            guest: levels.user.guest,
            version: cleverapps.config.version
        };

        if (["garden", "ladacha", "woodenmerge2"].includes(cleverapps.config.name)) {
            header.repair = {
                room: cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION}_room`) || 0,
                building: cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION}_building`) || 0,
                stage: cleverapps.dataLoader.load(`${DataLoader.TYPES.LOCATION}_stage`) || 0
            };
        }

        return header;
    },

    progressComparator: function (localHeader, remoteSync) {
        const loadUser = (user) => ({
            episode: +user.episode || 0,
            level: +user.level || 0,
            exp: +user.exp || 0,
            progress: +user.progress || 0,
            progressCompare: +user.progressCompare || 0
        });

        const local = loadUser(localHeader);
        const remote = loadUser(remoteSync.users || {});

        let result = 0;

        if (["garden", "ladacha", "woodenmerge2"].includes(cleverapps.config.name)) {
            const remoteLoc = remoteSync.locations || {};
            const cR = localHeader.repair || {};
            result = ((cR.room || 0) - (remoteLoc.room || 0))
                || ((cR.building || 0) - (remoteLoc.building || 0))
                || ((cR.stage || 0) - (remoteLoc.stage || 0));
        } else if (["merge", "merge2", "farm"].includes(cleverapps.config.type)) {
            result = local.level - remote.level || local.exp - remote.exp;
        } else {
            result = local.episode - remote.episode || local.level - remote.level || local.progress - remote.progress;
        }

        return result || local.progressCompare - remote.progressCompare;
    }
};